import { render, staticRenderFns } from "./AYoutube.vue?vue&type=template&id=f4dfb256"
import script from "./AYoutube.vue?vue&type=script&lang=js"
export * from "./AYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports